import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import CarerRegisterPage from './CarerRegisterPage';
import CarerLoginPage from './CarerLoginPage';

const AuthPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  // 从URL参数获取初始模式，默认为login
  const initialMode = searchParams.get('mode') === 'register' ? 'register' : 'login';
  const [mode, setMode] = useState<'login' | 'register'>(initialMode);
  const { register, login, isAuthenticated, carer } = useAuth();
  const navigate = useNavigate();

  // 如果用户已认证，自动跳转到用户管理页面
  useEffect(() => {
    console.log('🔄 AuthPage useEffect 检查认证状态:', {
      isAuthenticated,
      carerName: carer?.name,
      timestamp: new Date().toISOString()
    });
    
    if (isAuthenticated && carer) {
      console.log('🔄 用户已认证，跳转到用户管理页面:', carer.name);
      // 稍微延迟跳转，确保React状态完全更新
      setTimeout(() => {
        navigate('/users');
      }, 100);
    }
  }, [isAuthenticated, carer, navigate]);

  // 注册成功处理
  const handleRegisterSuccess = async (token: string, carer: any) => {
    console.log('🎉 注册成功，自动登录完成');
    // AuthContext已经通过authService自动更新状态
    // 如果是从"开始免费评估"进来的，跳转到评估选择页面
    if (initialMode === 'register') {
      setTimeout(() => {
        navigate('/assessment-choice');
      }, 100);
    }
  };

  // 登录成功处理
  const handleLoginSuccess = async (token: string, carer: any) => {
    console.log('🎉 登录成功，准备跳转');
    // 如果是从"用户档案"进来的，跳转到用户管理页面（默认行为）
    // AuthContext状态已经更新，useEffect会自动处理跳转到 /users
  };

  // 处理模式切换，同时更新URL参数
  const handleSwitchToLogin = () => {
    setMode('login');
    navigate('/auth?mode=login');
  };

  const handleSwitchToRegister = () => {
    setMode('register');
    navigate('/auth?mode=register');
  };

  if (mode === 'register') {
    return (
      <CarerRegisterPage
        onRegisterSuccess={handleRegisterSuccess}
        onSwitchToLogin={handleSwitchToLogin}
      />
    );
  }

  return (
    <CarerLoginPage
      onLoginSuccess={handleLoginSuccess}
      onSwitchToRegister={handleSwitchToRegister}
    />
  );
};

export default AuthPage;